import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Tabs } from '@bynder/design-system';
import { useTranslate } from '@bynder/localization';
import { getDesignsDefaultLink, getProjectsDefaultLink } from 'packages/helpers/defaultLinks';
import { DesignsTab, DesignsTabsProps } from './types';
import { withView } from './utils';

const StyledTabs = styled(Tabs)`
    min-width: 520px;
`;

const DesignsTabs = ({ activeTab, isLocked, isListView }: DesignsTabsProps) => {
    const { translate } = useTranslate();
    const navigate = useNavigate();

    const handleTabClick = (tab: DesignsTab) => (e: React.MouseEvent) => {
        e.preventDefault();

        if (tab === activeTab || isLocked) {
            return;
        }

        navigate({
            pathname: tab === DesignsTab.DESIGNS ? getDesignsDefaultLink() : getProjectsDefaultLink(),
            search: isListView ? withView('', 'list') : '',
        });
    };

    return (
        <StyledTabs data-testid="designs overview : tabs">
            <Tabs.Tab
                label={translate('pages.designs.tabs.designs')}
                isActive={activeTab === DesignsTab.DESIGNS}
                onClick={handleTabClick(DesignsTab.DESIGNS)}
                data-testid="designs overview : designs tab"
            />
            <Tabs.Tab
                label={translate('pages.designs.tabs.projects')}
                isActive={activeTab === DesignsTab.PROJECTS}
                onClick={handleTabClick(DesignsTab.PROJECTS)}
                data-testid="designs overview : projects tab"
            />
        </StyledTabs>
    );
};

export default DesignsTabs;
